import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldAggrResponse } from '@/api/routes/stat/types';

import { fetchAggrDeviceSumAdTimeFieldAggr } from './actionCreators';

interface InitialState {
  aggrBySumAdTimeField: AggrDeviceFieldAggrResponse,
  prevAggrBySumAdTimeField: AggrDeviceFieldAggrResponse,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggrBySumAdTimeField: [],
  prevAggrBySumAdTimeField: [],
  isLoading: false,
  error: '',
};

export const aggrDeviceBySumAdTimeFieldSlice = createSlice({
  name: 'aggrDeviceBySumAdTimeField',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAggrDeviceSumAdTimeFieldAggr.fulfilled.type]: (state, action: PayloadAction<AggrDeviceFieldAggrResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.prevAggrBySumAdTimeField = state.aggrBySumAdTimeField;
      state.aggrBySumAdTimeField = action.payload;
    },
    [fetchAggrDeviceSumAdTimeFieldAggr.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchAggrDeviceSumAdTimeFieldAggr.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default aggrDeviceBySumAdTimeFieldSlice.reducer;
